// Gilbos Doubler
import React from "react";
import {
   ClockSettingRow, CommonRows, CreelTensionRow, InputRangeRow, ProgramRow,
   RunTimeRow, SpindleSpeedRow, WindingTensionRow
} from "./index";

export default function MachineDoubler() {
   return (
      <>
         <ClockSettingRow />
         <RunTimeRow />
         <ProgramRow hash />
         <InputRangeRow
            titleProp={"Number of Ends"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={15}
            propertyNameProp={"totalEnds"}
            errorDialogueProp={"1-15 only"}
            floatProp={false}
         />
         <CreelTensionRow />
         <WindingTensionRow windingTension />
         <SpindleSpeedRow />
         <CommonRows />
      </>
   );
}
